import { render, staticRenderFns } from "./EntityGroupTable.vue?vue&type=template&id=81e2efba"
import script from "./EntityGroupTable.vue?vue&type=script&lang=js"
export * from "./EntityGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports